import { imgLogo2 } from "@/shared/assets/img";

function AuthHeader() {
  return (
    <div className="flex items-center justify-between relative mb-7.5 h-9.5">
      <img src={imgLogo2} alt="Logo" className="h-8" />
    </div>
  );
}

export default AuthHeader;
